import React from 'react';
import { FooterLogo } from './FooterLogo';
import { Facebook, Instagram, Twitter } from 'lucide-react';
export function Footer() {
  return <footer className="bg-tx-deep text-white pt-20 pb-10" data-id="element-87">
      <div className="container mx-auto px-4" data-id="element-88">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-16" data-id="element-89">
          {/* Brand Column */}
          <div className="lg:col-span-2 pr-0 lg:pr-12" data-id="element-90">
            <div className="mb-6" data-id="element-91">
              <FooterLogo data-id="element-92" />
            </div>
            <p className="text-white/70 leading-relaxed mb-8 max-w-md" data-id="element-93">
              A roofing and outdoor living contractor serving DFW since 2017.
              Roof repairs, replacements, remodels, pools, and patios.
            </p>
            <div className="flex gap-4" data-id="element-94">
              <a href="https://facebook.com/TexasDirectRoofing" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-tx-red transition-colors" data-id="element-95">
                <Facebook className="w-5 h-5" data-id="element-96" />
              </a>
              <a href="https://instagram.com/txdroofing" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-tx-red transition-colors" data-id="element-97">
                <Instagram className="w-5 h-5" data-id="element-98" />
              </a>
              <a href="https://twitter.com/TXDroofing" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-tx-red transition-colors" data-id="element-99">
                <Twitter className="w-5 h-5" data-id="element-100" />
              </a>
            </div>
          </div>

          {/* Contact Column */}
          <div data-id="element-101">
            <h4 className="font-bold text-lg mb-6" data-id="element-102">Contact Us</h4>
            <ul className="space-y-4 text-white/70" data-id="element-103">
              <li data-id="element-104">
                <a href="tel:8177753540" className="hover:text-white transition-colors" data-id="element-105">
                  (817) 775-3540
                </a>
              </li>
              <li data-id="element-106">
                <a href="mailto:sales@txdroofing.com" className="hover:text-white transition-colors" data-id="element-107">
                  sales@txdroofing.com
                </a>
              </li>
              <li className="leading-relaxed" data-id="element-108">
                231 NE Loop 820
                <br data-id="element-109" />
                Hurst, TX 76053
              </li>
            </ul>
          </div>

          {/* Quick Links Column */}
          <div data-id="element-110">
            <h4 className="font-bold text-lg mb-6" data-id="element-111">Quick Links</h4>
            <ul className="space-y-3 text-white/70" data-id="element-112">
              <li data-id="element-113">
                <a href="#services" className="hover:text-white transition-colors" data-id="element-114">
                  Services
                </a>
              </li>
              <li data-id="element-115">
                <a href="#storm-damage" className="hover:text-white transition-colors" data-id="element-116">
                  Storm Damage
                </a>
              </li>
              <li data-id="element-117">
                <a href="#financing" className="hover:text-white transition-colors" data-id="element-118">
                  Financing
                </a>
              </li>
              <li data-id="element-119">
                <a href="#reviews" className="hover:text-white transition-colors" data-id="element-120">
                  Reviews
                </a>
              </li>
              <li data-id="element-121">
                <a href="#contact" className="hover:text-white transition-colors" data-id="element-122">
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-white/50" data-id="element-123">
          <p data-id="element-124">
            &copy; {new Date().getFullYear()} Texas Direct Roofing &
            Construction. All rights reserved.
          </p>
          <div className="flex items-center gap-4" data-id="element-125">
            <span data-id="element-126">RCAT #01-0501</span>
            <span className="hidden md:inline" data-id="element-127">•</span>
            <a href="#" className="hover:text-white transition-colors underline" data-id="element-128">
              Verify our license
            </a>
          </div>
        </div>
      </div>
    </footer>;
}